/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleKey = createReactComponent("circle-key", "IconCircleKey", [
  ["path", { d: "M14 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z", key: "svg-1" }],
  ["path", { d: "M12.5 11.5l-4 4l1.5 1.5", key: "svg-2" }],
  ["path", { d: "M12 15l-1.5 -1.5", key: "svg-3" }]
]);

export { IconCircleKey as default };
//# sourceMappingURL=IconCircleKey.js.map
